import { useState } from "react";

function BannerWatchVideo({ ytUrl }) {
  const [visible, setVisible] = useState(false);

  return (
    <>
    {/*
      <button
        onClick={() => setVisible(true)}
        className="banner-video-btn mb-4 btn btn-outline-warning d-flex align-items-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          width="24"
          height="24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
          />
        </svg>
        Watch Video
      </button>

      <div className={`video-youtube-popup ${visible && "show"}`}>
        <div className="wrapper">
          <div className="close-btn" onClick={() => setVisible(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </div>
          {visible && (
            <iframe
              width="560"
              height="315"
              src={ytUrl}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          )}
        </div>
      </div>
      */}
    </>
  );
}
export default BannerWatchVideo;
